<template>
    <div>

        <b-card>
            <p>Vue réduite</p>

            <div>Description</div>
            <b-input v-model="small.description"></b-input>

            <div>Paramètres</div>
            <b-checkbox v-model="small.show_params"></b-checkbox>

            <div>Type</div>

            <b-select v-model="small.type" :options="types"></b-select>
            <div v-show="small.type == 'nb_lines'">
                <div>Description (singulier)</div>
                <b-input v-model="small.text_s"></b-input>
                <div>Description (pluriel)</div>
                <b-input v-model="small.text_p"></b-input>
            </div>
            <div v-show="small.type == 'list'">
                <div>Template</div>
                <b-input v-model="small.template"></b-input>
            </div>
            <div v-show="small.type.startsWith('array')">
                <div>Voir le nombre de résultats</div>
                <b-checkbox v-model="small.view_nb_result"></b-checkbox>
                <div>Cacher les options des tableaux</div>
                <b-checkbox v-model="small.minimal_tabulator"></b-checkbox>
            </div>
            <div v-show="small.type == 'calendar'">
                <p>Colonne des dates</p>
                <b-input v-model="small.column_date"></b-input>
                <div>Template - titre</div>
                <b-input v-model="small.template"></b-input>
                <div>Template - description</div>
                <b-input v-model="small.template_desc"></b-input>
                <div>Nombre de mois - lignes</div>
                <b-input type="number" v-model="small.rows"></b-input>
                <div>Nombre de mois - colonnes</div>
                <b-input type="number" v-model="small.columns"></b-input>
            </div>
            <div v-show="small.type.startsWith('array')">
                <hr class="my-2">
                <div class="text-muted" style="font-size:0.85em;font-weight:600;">Graphique (optionnel)</div>
                <b-checkbox v-model="small.allow_chart_toggle" class="mt-1">Activer le bouton tableau ↔ graphique</b-checkbox>
                <div v-if="small.allow_chart_toggle">
                    <div class="mt-1">Vue par défaut</div>
                    <b-select v-model="small.chart_default_view"
                        :options="[{value:'table',text:'Tableau'},{value:'chart',text:'Graphique'}]" />
                    <chart-config ref="chartConfigSmallArr" :value="small.charts" @input="v => small.charts = v" />
                    <b-button size="sm" variant="outline-primary" class="mt-2" @click="loadPreviewSmall('chartConfigSmallArr')">
                        <i class="fas fa-eye"></i> Aperçu
                    </b-button>
                    <div v-if="previewSmallData.length > 0 && small.charts[previewSmallIndex]" class="mt-2">
                        <chart-display :key="previewKey"
                            :rows="previewSmallData" :config="small.charts[previewSmallIndex]" :editable="false" />
                    </div>
                </div>
            </div>
            <div v-show="small.type == 'chart_pie' || small.type == 'chart_line'">
                <chart-config ref="chartConfigSmallPie" :value="small.charts" @input="v => small.charts = v" />
                <b-button size="sm" variant="outline-primary" class="mt-2" @click="loadPreviewSmall('chartConfigSmallPie')">
                    <i class="fas fa-eye"></i> Aperçu
                </b-button>
                <div v-if="previewSmallData.length > 0 && small.charts[previewSmallIndex]" class="mt-2">
                    <chart-display :key="previewKey"
                        :rows="previewSmallData" :config="small.charts[previewSmallIndex]" :editable="false" />
                </div>
            </div>
        </b-card>

        <b-card>
            <p>Vue agrandie</p>

            <div>Description</div>
            <b-input v-model="big.description"></b-input>

            <div>Paramètres</div>
            <b-checkbox v-model="big.show_params"></b-checkbox>

            <div>Type</div>

            <b-select v-model="big.type" :options="types"></b-select>
            <div v-show="big.type == 'nb_lines'">
                <div>Description (singulier)</div>
                <b-input v-model="big.text_s"></b-input>
                <div>Description (pluriel)</div>
                <b-input v-model="big.text_p"></b-input>
            </div>
            <div v-show="big.type == 'list'">
                <div>Template - titre</div>
                <b-input v-model="big.template"></b-input>
            </div>
            <div v-show="big.type.startsWith('array')">
                <div>Voir le nombre de résultats</div>
                <b-checkbox v-model="big.view_nb_result"></b-checkbox>
                <div>Cacher les options des tableaux</div>
                <b-checkbox v-model="big.minimal_tabulator"></b-checkbox>
            </div>
            <div v-show="big.type == 'calendar'">
                <p>Colonne des dates</p>
                <b-input v-model="big.column_date"></b-input>
                <div>Template</div>
                <b-input v-model="big.template"></b-input>
                <div>Template - description</div>
                <b-input v-model="big.template_desc"></b-input>
                <div>Nombre de mois - lignes</div>
                <b-input type="number" v-model="big.rows"></b-input>
                <div>Nombre de mois - colonnes</div>
                <b-input type="number" v-model="big.columns"></b-input>
            </div>
            <div v-show="big.type.startsWith('array')">
                <hr class="my-2">
                <div class="text-muted" style="font-size:0.85em;font-weight:600;">Graphique (optionnel)</div>
                <b-checkbox v-model="big.allow_chart_toggle" class="mt-1">Activer le bouton tableau ↔ graphique</b-checkbox>
                <div v-if="big.allow_chart_toggle">
                    <div class="mt-1">Vue par défaut</div>
                    <b-select v-model="big.chart_default_view"
                        :options="[{value:'table',text:'Tableau'},{value:'chart',text:'Graphique'}]" />
                    <chart-config ref="chartConfigBigArr" :value="big.charts" @input="v => big.charts = v" />
                    <b-button size="sm" variant="outline-primary" class="mt-2" @click="loadPreviewBig('chartConfigBigArr')">
                        <i class="fas fa-eye"></i> Aperçu
                    </b-button>
                    <div v-if="previewBigData.length > 0 && big.charts[previewBigIndex]" class="mt-2">
                        <chart-display :key="previewKey"
                            :rows="previewBigData" :config="big.charts[previewBigIndex]" :editable="false" />
                    </div>
                </div>
            </div>
            <div v-show="big.type == 'chart_pie' || big.type == 'chart_line'">
                <chart-config ref="chartConfigBigPie" :value="big.charts" @input="v => big.charts = v" />
                <b-button size="sm" variant="outline-primary" class="mt-2" @click="loadPreviewBig('chartConfigBigPie')">
                    <i class="fas fa-eye"></i> Aperçu
                </b-button>
                <div v-if="previewBigData.length > 0 && big.charts[previewBigIndex]" class="mt-2">
                    <chart-display :key="previewKey"
                        :rows="previewBigData" :config="big.charts[previewBigIndex]" :editable="false" />
                </div>
            </div>
        </b-card>

        <div>Vue</div>

        <DatabaseRequestView :minimal="true" ref="view" />

    </div>

</template>

<script>
    import DatabaseRequestView from "../../views/DatabaseRequestView.vue";
    import ChartConfig, { defaultChartConfig } from "../ChartConfig.vue";
    import ChartDisplay from "../ChartDisplay.vue";

    export default {
		components: {
			DatabaseRequestView,
			ChartConfig,
			ChartDisplay
		},
        props: {
            params: {}
        },
        data: function () {
            return {
                types: [{
                    value: "array",
                    text: "Tableau"
                },{
                    value: "array_conditions",
                    text: "Tableau avec query builder"
                },
                {
                    value: "nb_lines",
                    text: "Nombre de lignes"
                },
                {
                    value: "list",
                    text: "Liste"
                },
                {
                    value: "calendar",
                    text: "Calendrier"
                },
                {
                    value: "chart_pie",
                    text: "Camembert"
                },
                {
                    value: "chart_line",
                    text: "Courbe (timeline)"
                }],
                small: {
                    type: "array",
                    text_s: "",
                    text_p: "",
                    template: "",
                    view_nb_result: true,
                    description: "",
                    column_date: "",
                    allow_chart_toggle: false,
                    chart_default_view: "table",
                    charts: [defaultChartConfig()]
                },
                big: {
                    type: "array",
                    text_s: "",
                    text_p: "",
                    template: "",
                    view_nb_result: true,
                    description: "",
                    column_date: "",
                    allow_chart_toggle: false,
                    chart_default_view: "table",
                    charts: [defaultChartConfig()]
                },
                previewData: [],
                previewKey: 0,
                previewSmallData: [],
                previewSmallIndex: 0,
                previewBigData: [],
                previewBigIndex: 0
            };
		},
		methods: {
            loadPreviewSmall(refName) {
                this.previewKey++;
                this.previewSmallIndex = this.$refs[refName] ? this.$refs[refName].activeTab : 0;
                this.previewSmallData = (this.$refs.view && this.$refs.view.data_test) ? this.$refs.view.data_test : [];
            },
            loadPreviewBig(refName) {
                this.previewKey++;
                this.previewBigIndex = this.$refs[refName] ? this.$refs[refName].activeTab : 0;
                this.previewBigData = (this.$refs.view && this.$refs.view.data_test) ? this.$refs.view.data_test : [];
            },
            loadPreview() {
                this.previewKey++;
                this.previewData = (this.$refs.view && this.$refs.view.data_test) ? this.$refs.view.data_test : [];
            },
            async save()
            {
                return {
                    params: await this.$refs.view.save(),
                    tparams: await this.$refs.view.save_params(),
                    small: this.small,
                    big: this.big
                }
            },
            async load(data)
            {
                console.log(data)

                if (data && data.params && typeof data.params == "string")
                    data.params = JSON.parse(data.params);

                if (data && data.params)
                    await this.$refs.view.set_name(data.params.name);
                if (data && data.tparams)
                    await this.$refs.view.load_params(data.tparams);

                if (data.small) {
                    this.small = data.small;
                    if (!this.small.charts) {
                        // Compat : ancien format (chart = objet unique)
                        const old = this.small.chart || {};
                        this.small.chart_default_view = old.default_view || 'table';
                        this.small.charts = [{
                            ...defaultChartConfig(),
                            type:            old.type            || 'pie',
                            data_mode:       old.data_mode       || 'count',
                            label_col:       old.label_col       || '',
                            date_trunc:      old.date_trunc      || false,
                            date_trunc_unit: old.date_trunc_unit || 'day',
                            value_col:       old.value_col       || '',
                            series_col:      old.series_col      || '',
                            title:           old.title           || ''
                        }];
                    }
                }

                if (data.big) {
                    this.big = data.big;
                    if (!this.big.charts) {
                        const old = this.big.chart || {};
                        this.big.chart_default_view = old.default_view || 'table';
                        this.big.charts = [{
                            ...defaultChartConfig(),
                            type:            old.type            || 'pie',
                            data_mode:       old.data_mode       || 'count',
                            label_col:       old.label_col       || '',
                            date_trunc:      old.date_trunc      || false,
                            date_trunc_unit: old.date_trunc_unit || 'day',
                            value_col:       old.value_col       || '',
                            series_col:      old.series_col      || '',
                            title:           old.title           || ''
                        }];
                    }
                }
            }
		},
		mounted: function () {
            if (this.params)
                this.load(this.params)
		},
    }


</script>